<template>
	<div class="review-popup">
		<div class="review-wr">
			<button class="review__close" @click="isReviewOpen = false">
				<Cross />
			</button>
			<h2>Оставить отзыв</h2>
			<div class="review__master" v-if="Object.keys(masterData).length">
				<span>Мастер:</span>
				<div class="review__master-wr">
					<img :src="masterData.avatar ? `/mediafiles/${masterData.avatar}` : '/staticfiles/vue/public/profile.png'" alt="">
					<span>{{ masterData.firstname + ' ' + masterData.lastname }}</span>
				</div>
			</div>
			<div class="review__content">
				<div class="input__field">
					<label for="number">Ваш телефон</label>
					<input
						id="number"
						type="text"
						placeholder="+7 ___ ___ __ __"
						v-maska="'+7 (###) ###-##-##'"
						v-model="reviewData.number"
					>
				</div>
				<div class="input__field">
					<label>Ваша оценка</label>
					<div class="review__stars">
						<button @click="reviewData.reviewCount = 1">
							<Star
								:strokeColor="reviewData.reviewCount >= 1 ? null : '#ABABAB'"
								:class="{'isActive': reviewData.reviewCount >= 1}"
							/>
						</button>
						<button @click="reviewData.reviewCount = 2">
							<Star
								:strokeColor="reviewData.reviewCount >= 2 ? null : '#ABABAB'"
								:class="{'isActive': reviewData.reviewCount >= 2}"
							/>
						</button>
						<button @click="reviewData.reviewCount = 3">
							<Star
								:strokeColor="reviewData.reviewCount >= 3 ? null : '#ABABAB'"
								:class="{'isActive': reviewData.reviewCount >= 3}"
							/>
						</button>
						<button @click="reviewData.reviewCount = 4">
							<Star
								:strokeColor="reviewData.reviewCount >= 4 ? null : '#ABABAB'"
								:class="{'isActive': reviewData.reviewCount >= 4}"
							/>
						</button>
						<button @click="reviewData.reviewCount = 5">
							<Star
								:strokeColor="reviewData.reviewCount == 5 ? null : '#ABABAB'"
								:class="{'isActive': reviewData.reviewCount == 5}"
							/>
						</button>
					</div>
				</div>
				<div class="input__field">
					<label for="comment">Ваш комментарий</label>
					<textarea
						id="comment"
						type="text"
						v-model="reviewData.comment"
					/>
				</div>
			</div>
			<button class="review__submit" :disabled="notAllowed" @click="handleSubmitReview">Отправить</button>
		</div>
	</div>
</template>
<script setup>
import { vMaska } from "maska/vue"
import { ref, computed, onMounted } from "vue";
import { useApi } from "@/composables/useApi";
import Cross from "./Icons/Cross.vue";
import Star from "./Icons/Star.vue";

const isReviewOpen = defineModel();

const { getMaster, setReviews } = useApi();

const masterData = ref({});

const client_phone = computed(() => {
	const params = new URLSearchParams(window.location.search);
	return params.get('client_phone') || '';
});

const code = computed(() => {
	const params = new URLSearchParams(window.location.search);
	return params.get('code') || '';
});

const master_id = computed(() => {
	const params = new URLSearchParams(window.location.search);
	return params.get('master_id') || '';
});

const reviewData  = ref({
	number      : client_phone.value,
	reviewCount : null,
	comment     : '',
});

const notAllowed = computed(() => {
	return reviewData.value.number.length < 18 || !reviewData.value.reviewCount;
})

const handleSubmitReview = async () => {
	try {
		const formData = new FormData();
		formData.append('client_phone', reviewData.value.number);
		formData.append('rating', reviewData.value.reviewCount);
		formData.append('code', code.value);
		formData.append('text', reviewData.value.comment);
		
		await setReviews(master_id.value, formData);
		isReviewOpen.value = false;
	} catch (e) {
		console.error(e);
	}
}

onMounted(async () => masterData.value = await getMaster(master_id.value) || {});
</script>
<style lang='scss'>
.review__close {
	position: absolute;
	right: 24px;
}

.review-popup {
	width: 100vw;
	height: 100vh;
	padding-inline: 32px;
	position: fixed;
	display: grid;
	place-items: center;
	background-color: rgba($color: #000000, $alpha: .4);

	.review__content {
		width: 100%;
		margin-top: 32px;
		display: grid;
		grid-template-columns: 280px 1fr;
		grid-template-rows: 1fr 1fr;
		gap: 24px;

		@media (max-width: 768px) { grid-template-columns: 200px 1fr }

		@media (max-width: 620px) {
			grid-template-columns: 1fr;
			grid-template-rows: auto auto 240px;
		}
	}
}

.review__master {
	width: 100%;
	margin-top: 24px;

	.review__master-wr {
		display: flex;
		gap: 12px;
		font-size: 14px;
		align-items: center;
		width: 240px;
		margin-top: 12px;
		padding: 12px 12px;
		background-color: #ECECEC;
		border-radius: 8px;

		img {
			width: 34px;
			height: 34px;
			border-radius: 4px;
		}
	}
}

.review-wr {
	width: 100%;
	max-width: 860px;
	height: auto;
	padding: 24px 42px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 20px;
	background-color: #FFF;

	h2 { font-size: 32px }

	@media (max-width: 620px) {
		h2 { font-size: 26px }
	}
}

.input__field {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 12px;

	input {
		width: 100%;
		height: 42px;
		padding-left: 20px;
		font-size: 16px;
		border: 1px solid #ADADAD;
		border-radius: 8px;
	}

	textarea {
		width: 100%;
		height: 100%;
		padding: 12px;
		resize: none;
		border: 1px solid #ADADAD;
		border-radius: 8px;
	}

	label {
		font-size: 14px;
		color: #8E8E8E;
	}

	&:nth-child(2) {
		width: 50%;
		grid-column: 1 / 2;
		grid-row: 2 / 3;
	}

	&:nth-child(3) { grid-row: 1 / 3 }

	@media (max-width: 620px) {
		&:nth-child(2) {
			grid-column: 1;
			grid-row: unset;
		}

		&:nth-child(3) { grid-row: unset }
	}
}

.review__stars {
	display: flex;
	color: transparent;

	button,
	svg {
		width: 100%;
		height: 100%;
	}

	svg.isActive {
		color: $yellow;
	}
}

.review__submit {
	width: 240px;
	height: 42px;
	margin-top: 42px;
	border-radius: 12px;
	color: #FFF;
	font-size: 16px;
	font-weight: 700;
	background-color: $yellow;

	@media (max-width: 420px) { width: 180px }
}
</style>